const StorageName = {
  name: 'DCR'
}
export default StorageName